import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as awards from '../../../../awards'
import * as project from '../project'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: project.RESOURCE.payload.dimension.partialId,
      partialId: project.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Award associated with this project',
    isOptional: true,
    name: 'Award',
    partialId: PartialId.Standard.create('award'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(awards.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
